import _ from 'lodash';
import React, { Fragment, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, ModalBody, ModalFooter, Button, Table, Form, Input, ToggleSwitch, ProgressBar } from "@gpstrackit/react-controls";
import { Grid, Card, CardContent, Box, Icon } from '@mui/material'

import { NotificationManager } from "Components/Notifications";

import Alert from '@mui/material/Alert';
//Internationalization
import { injectIntl } from 'react-intl';

import { HasPermission } from 'Core/security';
import { getBadget } from 'Core/data/Helpers';

//Actions
import {
    vidfleetConfigurationUploadModeHide,
    vidfleetConfigurationUploadModeSave,
    devicesCommonGetDevices,
    generateValidationCode,
    clearRedux
} from "Redux/actions";


const configureUploadMode = (props) => {
    const { messages } = props.intl;
    const dispatch = useDispatch();
    const formEdit = useRef(null);
    const tableRef = useRef(null);

    //Redux states    
    const loading = useSelector(state => state.vidfleetConfigurationUploadModeRedux.loading);
    const openModal = useSelector(state => state.vidfleetConfigurationUploadModeRedux.openModal);
    const saveResult = useSelector(state => state.vidfleetConfigurationUploadModeRedux.saveResult);
    const data = useSelector(state => state.vidfleetConfigurationUploadModeRedux.data);
    const devicesToRecibe = useSelector(state => state.devicesCommonRedux.devices);
    const loadingDevices = useSelector(state => state.devicesCommonRedux.loading);
    const user = useSelector(state => state.securityRedux.user);
    const manufacturers = useSelector(state => state.generalRedux.manufacturers);
    const { loadingVfCode, VfCodeResult } = useSelector(state => state.commonRedux);


    //Local states
    const [title, setTitle] = useState('configuration_upload_mode_title');
    const [settingsMode, setSettingsMode] = useState("ALL"); //["ALL", "GROUPS", "SPECIFIC"]
    const [lastConfig, setLastConfig] = useState(null);
    const [allEvents, setAllEvents] = useState("clip");
    const [allGroupEvents, setAllGroupEvents] = useState({ allAccelEvents: "clip", allDMSEvents: "clip", allADASEvents: "clip", allNavEvents: "clip" });
    const [mode, setMode] = useState("Bulk");
    const [step, setStep] = useState(props?.from === "devices" ? 1 : 0);
    const [devices, setDevices] = useState(props.initialDevices || []);
    const [applyScopes, setApplyScopes] = useState([props?.from ? props?.from === "manufacturer" ? "Default" : "Partial" : "Partial"]);
    const [errorMessage, setErrorMessage] = useState("");
    const [deviceSearchCriteria, setDeviceSearchCriteria] = useState("");
    const [allSpecificEvents, setAllSpecificEvents] = useState({

        //Accel
        accel: {
            SEVERE_BRAKE: "clip",
            HARD_BRAKE: "clip",
            POTENTIAL_INCIDENT_LOW: "clip",
            HARSH_BRAKE: "clip",
            HARSH_ACCEL: "clip",
            HARSH_TURN: "clip",
            SHARP_TURN: "clip",
            SEVERE_TURN: "clip",
            SEVERE_ACCEL: "clip",
            DRIVING_HEAVY_HIT: "clip",
            POTENTIAL_INCIDENT_MEDIUM: "clip",
            HARD_ACCEL: "clip",
            POTENTIAL_INCIDENT_HIGH: "clip",
            DRIVING_SUSPICIOUS_HIT: "clip",
            PARKING_MOTION: "clip",
            PARKING_HIT: "clip",
            PARKING_HEAVY_HIT: "clip",
            DRIVING_HIT: "clip",
        },
        //DMS
        dms: {
            USING_PHONE: "clip",
            IDLE_NO_DRIVER: "clip",
            SMOKING: "clip",
            DROWSINESS: "clip",
            NO_SEATBELT: "clip",
            NO_DRIVER: "clip",
            DAYDREAMING: "clip",
            YAWN: "clip",
            ASLEEP: "clip",
            DISTRACTED: "clip"
        },
        //ADAS
        adas: {
            FORWARD_COLLISION_WARNING: "clip",
            HEADWAY_MONITORING_WARNING: "clip",
            HEADWAY_MONITORING_EMERGENCY: "clip",
            LANE_DEPARTURE_WARNING: "clip",
            STOP_SIGN_VIOLATION: "clip",
            PEDESTRIAN_COLLISION: "clip",
            CYCLIST_COLLISION: "clip"
        },
        //Others
        others: {
            MANUAL: "clip",
            POWER_LOST: "clip"
        },
        //NAV
        nav: {
            SPEEDING: "clip",
            OVER_MAX_SPEED: "clip"
        }

    });
    const [applyScopesItems, setApplyScopesItems] = useState([
        { key: "Default", permissionKey: "vftcsd", msgKey: "vidfleet_configuration_apply_scopes_default" },
        { key: "All", permissionKey: "vftcsa", msgKey: "vidfleet_configuration_apply_scopes_all" },
        { key: "Partial", permissionKey: "vftcsp", msgKey: "vidfleet_configuration_apply_scopes_partial" }]);
    let [verificationCode, setVerificationCode] = useState("");
    const [sendfVC, setSendfVC] = useState(false);
    const [codeSent, setCodeSent] = useState(false);


    const hide = () => {

        dispatch(clearRedux("CONFIGURE_UPLOAD_MODE"))
        setLastConfig(null);
        setSettingsMode("ALL");
        setAllEvents("clip");
        setDevices([])
        setAllGroupEvents({ allAccelEvents: "clip", allDMSEvents: "clip", allADASEvents: "clip", allNavEvents: "clip" });
        setAllSpecificEvents({

            //Accel
            accel: {
                SEVERE_BRAKE: "clip",
                HARD_BRAKE: "clip",
                POTENTIAL_INCIDENT_LOW: "clip",
                HARSH_BRAKE: "clip",
                HARSH_ACCEL: "clip",
                HARSH_TURN: "clip",
                SHARP_TURN: "clip",
                SEVERE_TURN: "clip",
                SEVERE_ACCEL: "clip",
                DRIVING_HEAVY_HIT: "clip",
                POTENTIAL_INCIDENT_MEDIUM: "clip",
                HARD_ACCEL: "clip",
                POTENTIAL_INCIDENT_HIGH: "clip",
                DRIVING_SUSPICIOUS_HIT: "clip",
                PARKING_MOTION: "clip",
                PARKING_HIT: "clip",
                PARKING_HEAVY_HIT: "clip",
                DRIVING_HIT: "clip",
            },
            //DMS
            dms: {
                USING_PHONE: "clip",
                IDLE_NO_DRIVER: "clip",
                SMOKING: "clip",
                DROWSINESS: "clip",
                NO_SEATBELT: "clip",
                NO_DRIVER: "clip",
                DAYDREAMING: "clip",
                YAWN: "clip",
                ASLEEP: "clip",
                DISTRACTED: "clip"
            },
            //ADAS
            adas: {
                FORWARD_COLLISION_WARNING: "clip",
                HEADWAY_MONITORING_WARNING: "clip",
                HEADWAY_MONITORING_EMERGENCY: "clip",
                LANE_DEPARTURE_WARNING: "clip",
                STOP_SIGN_VIOLATION: "clip",
                PEDESTRIAN_COLLISION: "clip",
                CYCLIST_COLLISION: "clip"
            },
            others: {
                //Others
                MANUAL: "clip"
            },
            //NAV
            nav: {
                SPEEDING: "clip",
                OVER_MAX_SPEED: "clip"
            }

        });
        dispatch(vidfleetConfigurationUploadModeHide());
        setCodeSent(false);
    }

    const onValidSubmit = () => {

        let errorMsg = "";

        let deviceSearchCriteriaArr = deviceSearchCriteria.split(/[\s,;\t\n]+/);;

        if (deviceSearchCriteriaArr.length > 1) {
            let criterias = [];

            deviceSearchCriteriaArr.forEach(criteria => {
                let escCriteria = criteria.trim();

                let regx = /[^a-zA-Z0-9]/g;
                escCriteria = escCriteria.replace(regx, '');

                if (devices && devices.length) {
                    for (let index in devices) {
                        let device = devices[index];

                        if (device.esn != escCriteria) {
                            criterias.push(escCriteria);
                        }
                    }
                } else {
                    criterias.push(escCriteria);
                }
            });


            if (criterias.length) {
                dispatch(devicesCommonGetDevices(criterias));
                setDeviceSearchCriteria(criterias.join(" "));

            }
        } else {
            let isValid = true;

            for (let index in devices) {
                let device = devices[index];

                if (device.esn === deviceSearchCriteria) {
                    isValid = false;
                    errorMsg = "vidfleet_configuration_repetead_on_the_list";
                    break;
                }
            }

            if (isValid) {
                dispatch(devicesCommonGetDevices([deviceSearchCriteria]))
            }
        }
        setErrorMessage(errorMsg)
    }

    const onSubmit = () => {

        onValidSubmit();
    }

    const onValidRequiredFields = () => { }

    //resolve data from waylens response
    const resolveData = (data) => {
        let allEvents = true
        let groupEvents = true;
        let specificEvents = true;

        let accelEvents = true;
        let dmsEvents = true;
        let adasEvents = true
        let navevents = true;

        let config = null;
        let configGroupEvents = {};
        let firstValueAll = "";
        let firstValueAccel = "";
        let firstValueDms = "";
        let firstValueAdas = "";
        let firstValueNav = "";
        let firstValueOthers = "";

        if (props.mode === "Single" && props?.device) {
            if (data?.deviceConfig?.currentEventUploadMode && !_.isEmpty(data.deviceConfig.currentEventUploadMode)) {
                setAllSpecificEvents(data.deviceConfig.currentEventUploadMode);
                config = data.deviceConfig.currentEventUploadMode;
            } else if (data?.fleetConfig?.eventUploadMode && !_.isEmpty(data.fleetConfig.eventUploadMode)) {
                setAllSpecificEvents(data.fleetConfig.eventUploadMode);
                config = data.fleetConfig.eventUploadMode;
            }

            if (!config) {
                if (props?.device?.deviceModel?.name?.includes("4K") || props?.device?.deviceModel?.name?.includes("AIR2")) {
                    let allEvents = JSON.parse(JSON.stringify(allSpecificEvents));
                    setAllSpecificEvents(allEvents);
                    config = allEvents;
                } else {
                    let partialEvents = {};
                    partialEvents.accel = JSON.parse(JSON.stringify(allSpecificEvents.accel));
                    setAllSpecificEvents(partialEvents);
                    config = partialEvents;
                }
            }
        } else {

            if (data?.fleetConfig?.eventUploadMode && !_.isEmpty(data.fleetConfig.eventUploadMode)) {
                setAllSpecificEvents(data.fleetConfig.eventUploadMode);
                config = data.fleetConfig.eventUploadMode;
            }

            if (!config) {
                let allEvents = JSON.parse(JSON.stringify(allSpecificEvents));
                setAllSpecificEvents(allEvents);
                config = allEvents;
            }
        }

        //last config
        if (config) {
            setLastConfig(JSON.parse(JSON.stringify(config)))
        }

        //check
        if (config?.accel) {
            Object.entries(config.accel).map(([key, val], index) => {

                if (firstValueAccel == "") {
                    firstValueAccel = val;
                    firstValueAll = val;
                    configGroupEvents.allAccelEvents = firstValueAccel;
                } else {
                    if (firstValueAccel !== val) {
                        allEvents = false
                        groupEvents = false
                    }
                    if (firstValueAll !== val)
                        allEvents = false
                }
            });
        }
        if (config?.dms) {
            Object.entries(config.dms).map(([key, val], index) => {

                if (firstValueDms == "") {
                    firstValueDms = val;
                    configGroupEvents.allDMSEvents = firstValueDms;
                } else {
                    if (firstValueDms !== val) {
                        allEvents = false
                        groupEvents = false
                    }
                    if (firstValueAll !== val)
                        allEvents = false
                }
            });
        }
        if (config?.adas) {
            Object.entries(config.adas).map(([key, val], index) => {

                if (firstValueAdas == "") {
                    firstValueAdas = val;
                    configGroupEvents.allADASEvents = firstValueAdas;
                } else {
                    if (firstValueAdas !== val) {
                        allEvents = false
                        groupEvents = false
                    }
                    if (firstValueAll !== val)
                        allEvents = false
                }
            });
        }
        if (config?.nav) {
            Object.entries(config.nav).map(([key, val], index) => {

                if (firstValueNav == "") {
                    firstValueNav = val;
                    configGroupEvents.allNavEvents = firstValueNav;
                } else {
                    if (firstValueNav !== val) {
                        allEvents = false
                        groupEvents = false
                    }
                    if (firstValueAll !== val)
                        allEvents = false
                }
            });
        }
        if (config?.others) {
            Object.entries(config.others).map(([key, val], index) => {

                if (firstValueOthers == "") {
                    firstValueOthers = val;
                } else {
                    if (firstValueOthers !== val) {
                        allEvents = false
                        groupEvents = false
                    }
                    if (firstValueAll !== val)
                        allEvents = false
                }
            });
        }

        if (allEvents) {
            setSettingsMode("ALL");
            setAllEvents(firstValueAll);
            setAllGroupEvents({ allAccelEvents: firstValueAll, allDMSEvents: firstValueAll, allADASEvents: firstValueAll, allNavEvents: firstValueAll });
        } else if (groupEvents) {
            setSettingsMode("GROUPS");
            setAllGroupEvents(configGroupEvents)
        } else {
            setSettingsMode("SPECIFIC");
        }

        //if (props?.from === "devices")
        //  setStep(1)

    }

    //get steps to be render
    const getStepsRender = (step) => {

        switch (step) {
            case 0:
                return (

                    <Card>
                        {
                            <CardContent>
                                <Form
                                    ref={formEdit}
                                    onValidSubmit={onValidSubmit}
                                    onSubmit={onSubmit}
                                    onValidRequiredFields={onValidRequiredFields}
                                >
                                    <Grid>
                                        <Grid container>
                                            <Grid xs={12}>
                                                {messages['vidfleet_configuration_apply_scopes']}
                                                <Grid>
                                                    {
                                                        applyScopesItems.map((item, index) => {
                                                            if (HasPermission(user, item.permissionKey, "u"))
                                                                return (
                                                                    <div className="d-sm-inline-block mb-1" key={`apply-scopes-${item.key}`} style={{ marginLeft: `${item.key !== "Default" ? "10px" : "0px"}` }}>
                                                                        <div
                                                                            onClick={e => {
                                                                                let applyScps = applyScopes;
                                                                                if (applyScps.includes(item.key)) {
                                                                                    applyScps.splice(applyScps.indexOf(item.key), 1);
                                                                                } else if (item.key === "Partial") {
                                                                                    applyScps = ["Partial"];
                                                                                } else {
                                                                                    if (applyScps.includes("Partial") && item.key != "Partial") {
                                                                                        applyScps.splice(applyScps.indexOf("Partial"), 1);
                                                                                    }
                                                                                    applyScps.push(item.key);
                                                                                }
                                                                                setApplyScopes([...applyScps]);
                                                                            }}
                                                                        >
                                                                            {
                                                                                getBadget(messages[item.msgKey], applyScopes.includes(item.key))
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                )
                                                        })
                                                    }
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} style={{ marginTop: 10 }}>
                                                {
                                                    applyScopes.includes("Default") &&
                                                    <Alert severity="error">
                                                        <span>{messages["vidfleet_configuration_apply_scopes_default_message"]}</span>
                                                    </Alert>
                                                }
                                                {
                                                    applyScopes.includes("All") &&
                                                    <Alert style={{ marginTop: 3 }} severity="error">
                                                        <span>{messages["vidfleet_configuration_apply_scopes_all_message"]}</span>
                                                    </Alert>
                                                }
                                                {
                                                    applyScopes.includes("Partial") &&
                                                    <Alert severity="info">
                                                        <span>{messages["vidfleet_configuration_apply_scopes_partial_message"]}</span>
                                                    </Alert>
                                                }
                                            </Grid>
                                        </Grid>
                                        {
                                            applyScopes.includes("Partial") &&
                                            <Grid container spacing={1} style={{ marginTop: 10 }}>

                                                <Grid item xs={6} style={{ marginTop: 10 }}>
                                                    <Input
                                                        name="deviceSearchCriteria"
                                                        id="deviceSearchCriteria"
                                                        ref="deviceSearchCriteria"
                                                        label={messages['vidfleet_configuration_device_search_criteria']}
                                                        placeholder={messages["vidfleet_configuration_device_search_criteria"]}
                                                        value={deviceSearchCriteria || ''}
                                                        onChange={(value) => {
                                                            setDeviceSearchCriteria(value);
                                                            setErrorMessage("")
                                                        }}
                                                        required
                                                        requiredMessage={messages['common_field_required']}
                                                        maxLength={500000}
                                                    />

                                                    {
                                                        errorMessage
                                                        &&
                                                        <span className="fg-danger fs-13">
                                                            {messages[errorMessage]}
                                                        </span>
                                                    }
                                                </Grid>

                                                <Grid item xs={3} style={{ marginTop: 34 }}>
                                                    <Button
                                                        size="lg"
                                                        className="btn btn-dark-blue"
                                                        disabled={loadingDevices}
                                                        onClick={() => {
                                                            //onValidSubmit();
                                                        }}
                                                    >
                                                        {messages["vidfleet_configuration_device_add"]}
                                                    </Button>
                                                </Grid>

                                            </Grid>
                                        }
                                    </Grid>
                                </Form>
                                {
                                    //devices grid
                                    applyScopes.includes("Partial") &&
                                    <Grid>
                                        <Grid item xs={12}>
                                            <div style={{ width: '100%', marginTop: 15 }}>
                                                <Table
                                                    ref={tableRef}
                                                    hidePagination
                                                    disableItemSelection
                                                    data={devices}
                                                    columns={[
                                                        {
                                                            key: 1,
                                                            show: true,
                                                            locked: true,
                                                            title: messages["vidfleet_configuration_esn"],
                                                            width: 50,
                                                            field: "esn",
                                                            render: (item) => {
                                                                return (
                                                                    <span>{item.esn || ''}</span>
                                                                )
                                                            }
                                                        },
                                                        {
                                                            key: 2,
                                                            show: true,
                                                            locked: false,
                                                            title: messages["vidfleet_configuration_model"],
                                                            width: 150,
                                                            field: "deviceModel",
                                                            sort: true,
                                                            resize: true,
                                                            render: (item) => {
                                                                return (
                                                                    <span>{item?.deviceModel?.name || ''}</span>
                                                                )
                                                            }
                                                        },
                                                        {
                                                            key: 3,
                                                            show: true,
                                                            locked: false,
                                                            title: "",
                                                            width: 50,
                                                            sort: true,
                                                            resize: true,
                                                            render: (item) => {
                                                                return (
                                                                    <span
                                                                        id="remove-button"
                                                                        className="cursor-pointer"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            let current = devices.lastIndexOf(item);
                                                                            let currentDevices = devices
                                                                            currentDevices.splice(current, 1);
                                                                            setDevices([...currentDevices]);

                                                                        }}
                                                                    >
                                                                        <Icon className="toolbar-list-icon">
                                                                            remove_circle
                                                                        </Icon>
                                                                    </span>
                                                                )
                                                            }
                                                        }
                                                    ]}
                                                />
                                            </div>
                                        </Grid>
                                    </Grid>
                                }
                            </CardContent>
                        }
                    </Card>
                )
            case 1:
                return (
                    <Card>
                        <CardContent>
                            <Grid
                                container
                                spacing={1}
                            >
                                <Grid item xs={12} >
                                    <div className="d-sm-inline-block mb-1" key={"all-events"}
                                        onClick={e => {
                                            setSettingsMode("ALL")
                                        }}
                                    >
                                        {
                                            getBadget(messages["configuration_upload_mode_all_events"], settingsMode === "ALL")
                                        }
                                    </div>

                                    <div className="d-sm-inline-block mb-1" key={"group-events"} style={{ marginLeft: 20 }}
                                        onClick={e => {
                                            setSettingsMode("GROUPS")
                                        }}
                                    >
                                        {
                                            getBadget(messages["configuration_upload_mode_group_events"], settingsMode === "GROUPS")
                                        }
                                    </div>

                                    <div className="d-sm-inline-block mb-1" key={"high-bit-rate-super-warning"} style={{ marginLeft: 20 }}
                                        onClick={e => {
                                            setSettingsMode("SPECIFIC")
                                        }}
                                    >
                                        {
                                            getBadget(messages["configuration_upload_mode_specific_events"], settingsMode === "SPECIFIC")
                                        }
                                    </div>

                                </Grid>

                                {
                                    (mode === "Single" && !props?.device?.esn) && !codeSent &&
                                    <Grid xs={12} style={{ marginTop: 20 }}>
                                        <a className="btn-link align-middle" onClick={() => {
                                            //to send the verification code
                                            let manufacturer = manufacturers.find(x => x?.name?.toUpperCase() === "VidFleet".toUpperCase())
                                            dispatch(generateValidationCode("updateVidFleetEventUploadMode", "VidFleet", manufacturer?.id))
                                            setSendfVC(true);
                                            setCodeSent(true);
                                        }}>
                                            {messages["vidfleet_configuration_send_verification_code"]}
                                        </a>
                                    </Grid>
                                }
                                {
                                    (mode === "Single" && !props?.device?.esn) &&
                                    <Grid xs={12} style={{ marginTop: 20 }}>
                                        <Input
                                            type="text"
                                            label={messages['vidfleet_configuration_verification_code']}
                                            placeholder={messages['vidfleet_configuration_verification_code']}
                                            value={verificationCode || ""}
                                            autoComplete="off"
                                            onChange={(value) => setVerificationCode(value?.trim())}
                                            requiredMessage={messages['required_field']}
                                            required
                                            maxLength={20}
                                        />
                                    </Grid>
                                }

                                {
                                    (applyScopes.includes("Default") || applyScopes.includes("All")) &&
                                    <Grid item xs={12} style={{ marginTop: 10 }}>
                                        {
                                            applyScopes.includes("Default") &&
                                            <Alert severity="error">
                                                <span>{messages["vidfleet_configuration_apply_scopes_default_message"]}</span>
                                            </Alert>
                                        }
                                        {
                                            applyScopes.includes("All") &&
                                            <Alert style={{ marginTop: 3 }} severity="error">
                                                <span>{messages["vidfleet_configuration_apply_scopes_all_message"]}</span>
                                            </Alert>
                                        }
                                    </Grid>
                                }
                                {
                                    settingsMode === "ALL" &&
                                    <Grid item xs={12} style={{ marginTop: 15 }}>
                                        <Grid item xs={12}>
                                            {messages["configuration_upload_mode_all_events"]}
                                        </Grid>
                                        <Grid item xs={12}>
                                            <div
                                                className="d-sm-inline-block mb-1 vidfleet-pills"
                                                key="configuration_upload_mode_all_events-none"
                                                onClick={e => {
                                                    setAllEvents("none");
                                                }}
                                            >
                                                {
                                                    getBadget(messages["configuration_upload_mode_none"], allEvents === "none")
                                                }
                                            </div>
                                            <div
                                                className="d-sm-inline-block mb-1 vidfleet-pills"
                                                key="configuration_upload_mode_all_events-clip"
                                                onClick={e => {
                                                    setAllEvents("clip");
                                                }}
                                            >
                                                {
                                                    getBadget(messages["configuration_upload_mode_clip"], allEvents === "clip")
                                                }
                                            </div>
                                            <div
                                                className="d-sm-inline-block mb-1 vidfleet-pills"
                                                key="configuration_upload_mode_all_events-picture"
                                                onClick={e => {
                                                    setAllEvents("picture");
                                                }}
                                            >
                                                {
                                                    getBadget(messages["configuration_upload_mode_picture"], allEvents === "picture")
                                                }
                                            </div>
                                        </Grid>
                                    </Grid>
                                }
                                {
                                    settingsMode === "GROUPS" &&
                                    <Box sx={{ flexGrow: 1 }}>
                                        <Grid container style={{ marginTop: 5 }}>
                                            {
                                                allSpecificEvents?.accel &&
                                                <Grid item xs={4} style={{ marginTop: 15 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_all_accel_events"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allAccelEvents-none"
                                                            onClick={e => {
                                                                allGroupEvents.allAccelEvents = "none";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allGroupEvents.allAccelEvents === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allAccelEvents-clip"
                                                            onClick={e => {
                                                                allGroupEvents.allAccelEvents = "clip";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allGroupEvents.allAccelEvents === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allAccelEvents-picture"
                                                            onClick={e => {
                                                                allGroupEvents.allAccelEvents = "picture";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allGroupEvents.allAccelEvents === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            }
                                            {
                                                ((props.mode === "Bulk" && ((devices.length > 0 && (devices[0].deviceModel.name === "4K" || devices[0].deviceModel.name === "AIR2")) || !applyScopes.includes("Partial"))) || (props.mode === "Single" && allSpecificEvents?.dms)) &&
                                                <Grid item xs={4} style={{ marginTop: 15 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_all_dms_events"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allDMSEvents-none"
                                                            onClick={e => {
                                                                allGroupEvents.allDMSEvents = "none";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allGroupEvents.allDMSEvents === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allDMSEvents-clip"
                                                            onClick={e => {
                                                                allGroupEvents.allDMSEvents = "clip";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allGroupEvents.allDMSEvents === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allDMSEvents-picture"
                                                            onClick={e => {
                                                                allGroupEvents.allDMSEvents = "picture";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allGroupEvents.allDMSEvents === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            }
                                            {
                                                ((props.mode === "Bulk" && ((devices.length > 0 && (devices[0].deviceModel.name === "4K" || devices[0].deviceModel.name === "AIR")) || !applyScopes.includes("Partial"))) || (props.mode === "Single" && allSpecificEvents?.adas)) &&
                                                <Grid item xs={4} style={{ marginTop: 15 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_all_dms_events"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allADASEvents-none"
                                                            onClick={e => {
                                                                allGroupEvents.allADASEvents = "none";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allGroupEvents.allADASEvents === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allADASEvents-clip"
                                                            onClick={e => {
                                                                allGroupEvents.allADASEvents = "clip";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allGroupEvents.allADASEvents === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allADASEvents-picture"
                                                            onClick={e => {
                                                                allGroupEvents.allADASEvents = "picture";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allGroupEvents.allADASEvents === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            }
                                            {
                                                ((props.mode === "Bulk" && ((devices.length > 0 && (devices[0].deviceModel.name === "4K" || devices[0].deviceModel.name === "AIR")) || !applyScopes.includes("Partial"))) || (props.mode === "Single" && allSpecificEvents?.adas)) &&
                                                <Grid item xs={4} style={{ marginTop: 15 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_all_nav_events"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allNavEvents-none"
                                                            onClick={e => {
                                                                allGroupEvents.allNavEvents = "none";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allGroupEvents.allNavEvents === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allNavEvents-clip"
                                                            onClick={e => {
                                                                allGroupEvents.allNavEvents = "clip";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allGroupEvents.allNavEvents === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_allNavEvents-picture"
                                                            onClick={e => {
                                                                allGroupEvents.allNavEvents = "picture";
                                                                setAllGroupEvents({ ...allGroupEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allGroupEvents.allNavEvents === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            }
                                        </Grid>
                                    </Box>
                                }
                                {
                                    settingsMode === "SPECIFIC" &&
                                    <Grid container style={{ marginTop: 5 }}>
                                        {
                                            allSpecificEvents?.accel &&
                                            <Grid container style={{ marginTop: 5 }}>
                                                <Grid item xs={12} style={{ marginTop: 15 }}>
                                                    <Fragment>
                                                        <label >
                                                            {messages["configuration_upload_mode_accel_events"]}
                                                        </label>
                                                    </Fragment>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_severe_brake"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SEVERE_BRAKE-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SEVERE_BRAKE = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.SEVERE_BRAKE === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SEVERE_BRAKE-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SEVERE_BRAKE = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.SEVERE_BRAKE === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SEVERE_BRAKE-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SEVERE_BRAKE = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.SEVERE_BRAKE === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_hard_brake"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARD_BRAKE-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARD_BRAKE = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.HARD_BRAKE === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARD_BRAKE-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARD_BRAKE = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.HARD_BRAKE === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARD_BRAKE-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARD_BRAKE = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.HARD_BRAKE === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_harsh_brake"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARSH_BRAKE-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARSH_BRAKE = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.HARSH_BRAKE === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARSH_BRAKE-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARSH_BRAKE = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.HARSH_BRAKE === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARSH_BRAKE-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARSH_BRAKE = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.HARSH_BRAKE === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_harsh_accel"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARSH_ACCEL-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARSH_ACCEL = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.HARSH_ACCEL === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARSH_ACCEL-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARSH_ACCEL = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.HARSH_ACCEL === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARSH_ACCEL-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARSH_ACCEL = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.HARSH_ACCEL === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_harsh_turn"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARSH_TURN-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARSH_TURN = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.HARSH_TURN === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARSH_TURN-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARSH_TURN = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.HARSH_TURN === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARSH_TURN-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARSH_TURN = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.HARSH_TURN === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_sharp_turn"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SHARP_TURN-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SHARP_TURN = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.SHARP_TURN === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SHARP_TURN-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SHARP_TURN = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.SHARP_TURN === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SHARP_TURN-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SHARP_TURN = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.SHARP_TURN === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_severe_turn"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SEVERE_TURN-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SEVERE_TURN = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.SEVERE_TURN === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SEVERE_TURN-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SEVERE_TURN = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.SEVERE_TURN === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SEVERE_TURN-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SEVERE_TURN = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.SEVERE_TURN === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_severe_accel"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SEVERE_ACCEL-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SEVERE_ACCEL = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.SEVERE_ACCEL === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SEVERE_ACCEL-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SEVERE_ACCEL = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.SEVERE_ACCEL === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SEVERE_ACCEL-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.SEVERE_ACCEL = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.SEVERE_ACCEL === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_driving_heavy_hit"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DRIVING_HEAVY_HIT-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.DRIVING_HEAVY_HIT = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.DRIVING_HEAVY_HIT === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DRIVING_HEAVY_HIT-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.DRIVING_HEAVY_HIT = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.DRIVING_HEAVY_HIT === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DRIVING_HEAVY_HIT-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.DRIVING_HEAVY_HIT = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.DRIVING_HEAVY_HIT === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_hard_accel"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARD_ACCEL-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARD_ACCEL = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.HARD_ACCEL === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARD_ACCEL-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARD_ACCEL = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.HARD_ACCEL === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HARD_ACCEL-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.HARD_ACCEL = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.HARD_ACCEL === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_potential_incident_low"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_LOW-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_LOW = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.POTENTIAL_INCIDENT_LOW === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_LOW-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_LOW = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.POTENTIAL_INCIDENT_LOW === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_LOW-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_LOW = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.POTENTIAL_INCIDENT_LOW === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_potential_incident_medium"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_MEDIUM-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_MEDIUM = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.POTENTIAL_INCIDENT_MEDIUM === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_MEDIUM-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_MEDIUM = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.POTENTIAL_INCIDENT_MEDIUM === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_MEDIUM-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_MEDIUM = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.POTENTIAL_INCIDENT_MEDIUM === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_potential_incident_high"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_HIGH-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_HIGH-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_HIGH-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_driving_suspicious_hit"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_HIGH-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_HIGH-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POTENTIAL_INCIDENT_HIGH-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.POTENTIAL_INCIDENT_HIGH === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_parking_motion"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PARKING_MOTION-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.PARKING_MOTION = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.PARKING_MOTION === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PARKING_MOTION-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.PARKING_MOTION = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.PARKING_MOTION === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PARKING_MOTION-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.PARKING_MOTION = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.PARKING_MOTION === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_parking_hit"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PARKING_HIT-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.PARKING_HIT = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.PARKING_HIT === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PARKING_HIT-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.PARKING_HIT = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.PARKING_HIT === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PARKING_HIT-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.PARKING_HIT = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.PARKING_HIT === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_parking_heavy_hit"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PARKING_HEAVY_HIT-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.PARKING_HEAVY_HIT = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.PARKING_HEAVY_HIT === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PARKING_HEAVY_HIT-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.PARKING_HEAVY_HIT = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.PARKING_HEAVY_HIT === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PARKING_HEAVY_HIT-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.PARKING_HEAVY_HIT = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.PARKING_HEAVY_HIT === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_driving_hit"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DRIVING_HIT-none"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.DRIVING_HIT = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.accel.DRIVING_HIT === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DRIVING_HIT-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.DRIVING_HIT = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.accel.DRIVING_HIT === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DRIVING_HIT-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.accel.DRIVING_HIT = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.accel.DRIVING_HIT === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                        {
                                            ((props.mode === "Bulk" && ((devices.length > 0 && (devices[0].deviceModel.name === "4K" || devices[0].deviceModel.name === "AIR2")) || !applyScopes.includes("Partial"))) || (props.mode === "Single" && allSpecificEvents?.dms)) &&
                                            <Grid container style={{ marginTop: 5 }}>
                                                <Grid item xs={12} style={{ marginTop: 15 }}>
                                                    <Fragment>
                                                        <label >
                                                            {messages["configuration_upload_mode_dms_events"]}
                                                        </label>
                                                    </Fragment>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_using_phone"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_USING_PHONE-none"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.USING_PHONE = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.dms.USING_PHONE === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_USING_PHONE-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.USING_PHONE = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.dms.USING_PHONE === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_USING_PHONE-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.USING_PHONE = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.dms.USING_PHONE === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_smoking"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SMOKING-none"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.SMOKING = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.dms.SMOKING === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SMOKING-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.SMOKING = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.dms.SMOKING === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SMOKING-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.SMOKING = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.dms.SMOKING === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_drowsiness"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DROWSINESS-none"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.DROWSINESS = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.dms.DROWSINESS === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DROWSINESS-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.DROWSINESS = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.dms.DROWSINESS === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DROWSINESS-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.DROWSINESS = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.dms.DROWSINESS === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_no_seatbelt"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_NO_SEATBELT-none"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.NO_SEATBELT = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.dms.NO_SEATBELT === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_NO_SEATBELT-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.NO_SEATBELT = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.dms.NO_SEATBELT === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_NO_SEATBELT-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.NO_SEATBELT = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.dms.NO_SEATBELT === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_no_driver"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_NO_DRIVER-none"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.NO_DRIVER = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.dms.NO_DRIVER === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_NO_DRIVER-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.NO_DRIVER = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.dms.NO_DRIVER === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_NO_DRIVER-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.NO_DRIVER = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.dms.NO_DRIVER === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_daydreaming"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DAYDREAMING-none"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.DAYDREAMING = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.dms.DAYDREAMING === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DAYDREAMING-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.DAYDREAMING = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.dms.DAYDREAMING === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DAYDREAMING-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.DAYDREAMING = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.dms.DAYDREAMING === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_yawn"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_YAWN-none"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.YAWN = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.dms.YAWN === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_YAWN-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.YAWN = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.dms.YAWN === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_YAWN-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.YAWN = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.dms.YAWN === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_asleep"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_ASLEEP-none"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.ASLEEP = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.dms.ASLEEP === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_ASLEEP-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.ASLEEP = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.dms.ASLEEP === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_ASLEEP-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.ASLEEP = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.dms.ASLEEP === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_distracted"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DISTRACTED-none"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.DISTRACTED = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.dms.DISTRACTED === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DISTRACTED-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.DISTRACTED = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.dms.DISTRACTED === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_DISTRACTED-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.DISTRACTED = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.dms.DISTRACTED === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={4} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_idle_no_driver"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_IDLE_NO_DRIVER-none"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.IDLE_NO_DRIVER = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.dms.IDLE_NO_DRIVER === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_IDLE_NO_DRIVER-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.IDLE_NO_DRIVER = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.dms.IDLE_NO_DRIVER === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_IDLE_NO_DRIVER-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.dms.IDLE_NO_DRIVER = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.dms.IDLE_NO_DRIVER === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                        {
                                            ((props.mode === "Bulk" && ((devices.length > 0 && (devices[0].deviceModel.name === "4K" || devices[0].deviceModel.name === "AIR")) || !applyScopes.includes("Partial"))) || (props.mode === "Single" && allSpecificEvents?.adas)) &&
                                            <Grid container style={{ marginTop: 5 }}>
                                                <Grid item xs={12} style={{ marginTop: 15 }}>
                                                    <Fragment>
                                                        <label >
                                                            {messages["configuration_upload_mode_adas_events"]}
                                                        </label>
                                                    </Fragment>
                                                </Grid>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_forward_collision_warning"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_FORWARD_COLLISION_WARNING-none"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.FORWARD_COLLISION_WARNING = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.adas.FORWARD_COLLISION_WARNING === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_FORWARD_COLLISION_WARNING-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.FORWARD_COLLISION_WARNING = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.adas.FORWARD_COLLISION_WARNING === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_FORWARD_COLLISION_WARNING-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.FORWARD_COLLISION_WARNING = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.adas.FORWARD_COLLISION_WARNING === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_headway_monitoring_warning"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HEADWAY_MONITORING_WARNING-none"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.HEADWAY_MONITORING_WARNING = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.adas.HEADWAY_MONITORING_WARNING === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HEADWAY_MONITORING_WARNING-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.HEADWAY_MONITORING_WARNING = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.adas.HEADWAY_MONITORING_WARNING === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HEADWAY_MONITORING_WARNING-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.HEADWAY_MONITORING_WARNING = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.adas.HEADWAY_MONITORING_WARNING === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_headway_monitoring_emergency"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HEADWAY_MONITORING_EMERGENCY-none"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.HEADWAY_MONITORING_EMERGENCY = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.adas.HEADWAY_MONITORING_EMERGENCY === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HEADWAY_MONITORING_EMERGENCY-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.HEADWAY_MONITORING_EMERGENCY = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.adas.HEADWAY_MONITORING_EMERGENCY === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_HEADWAY_MONITORING_EMERGENCY-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.HEADWAY_MONITORING_EMERGENCY = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.adas.HEADWAY_MONITORING_EMERGENCY === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_lane_departure_warning"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_LANE_DEPARTURE_WARNING-none"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.LANE_DEPARTURE_WARNING = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.adas.LANE_DEPARTURE_WARNING === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_LANE_DEPARTURE_WARNING-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.LANE_DEPARTURE_WARNING = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.adas.LANE_DEPARTURE_WARNING === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_LANE_DEPARTURE_WARNING-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.LANE_DEPARTURE_WARNING = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.adas.LANE_DEPARTURE_WARNING === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_stop_sign_violation"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_STOP_SIGN_VIOLATION-none"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.STOP_SIGN_VIOLATION = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.adas.STOP_SIGN_VIOLATION === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_STOP_SIGN_VIOLATION-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.STOP_SIGN_VIOLATION = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.adas.STOP_SIGN_VIOLATION === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_STOP_SIGN_VIOLATION-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.STOP_SIGN_VIOLATION = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.adas.STOP_SIGN_VIOLATION === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_pedestrian_collision"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PEDESTRIAN_COLLISION-none"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.PEDESTRIAN_COLLISION = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.adas.PEDESTRIAN_COLLISION === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PEDESTRIAN_COLLISION-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.PEDESTRIAN_COLLISION = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.adas.PEDESTRIAN_COLLISION === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_PEDESTRIAN_COLLISION-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.PEDESTRIAN_COLLISION = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.adas.PEDESTRIAN_COLLISION === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_cyclist_collision"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_CYCLIST_COLLISION-none"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.CYCLIST_COLLISION = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.adas.CYCLIST_COLLISION === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_CYCLIST_COLLISION-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.CYCLIST_COLLISION = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.adas.CYCLIST_COLLISION === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_CYCLIST_COLLISION-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.adas.CYCLIST_COLLISION = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.adas.CYCLIST_COLLISION === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                        {
                                            ((props.mode === "Bulk" && ((devices.length > 0 && (devices[0].deviceModel.name === "4K" || devices[0].deviceModel.name === "AIR2")) || !applyScopes.includes("Partial"))) || (props.mode === "Single" && allSpecificEvents?.others)) &&
                                            <Grid container style={{ marginTop: 5 }}>
                                                <Grid item xs={12} style={{ marginTop: 15 }}>
                                                    <Fragment>
                                                        <label >
                                                            {messages["configuration_upload_mode_nav"]}
                                                        </label>
                                                    </Fragment>
                                                </Grid>
                                                < Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_speeding"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SPEEDING-none"
                                                            onClick={e => {
                                                                
                                                                if (!allSpecificEvents.nav)
                                                                    allSpecificEvents.nav = {}
                                                                allSpecificEvents.nav.SPEEDING = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents?.nav?.SPEEDING === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SPEEDING-clip"
                                                            onClick={e => {
                                                                if (!allSpecificEvents.nav)
                                                                    allSpecificEvents.nav = {}
                                                                allSpecificEvents.nav.SPEEDING = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents?.nav?.SPEEDING === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_SPEEDING-picture"
                                                            onClick={e => {
                                                                if (!allSpecificEvents.nav)
                                                                    allSpecificEvents.nav = {}
                                                                allSpecificEvents.nav.SPEEDING = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents?.nav?.SPEEDING === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_over_max_speed"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_OVER_MAX_SPEED-none"
                                                            onClick={e => {
                                                                if (!allSpecificEvents.nav)
                                                                    allSpecificEvents.nav = {}
                                                                allSpecificEvents.nav.OVER_MAX_SPEED = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents?.nav?.OVER_MAX_SPEED === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_OVER_MAX_SPEED-clip"
                                                            onClick={e => {
                                                                if (!allSpecificEvents.nav)
                                                                    allSpecificEvents.nav = {}
                                                                allSpecificEvents.nav.OVER_MAX_SPEED = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents?.nav?.OVER_MAX_SPEED === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_OVER_MAX_SPEED-picture"
                                                            onClick={e => {
                                                                if (!allSpecificEvents.nav)
                                                                    allSpecificEvents.nav = {}
                                                                allSpecificEvents.nav.OVER_MAX_SPEED = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents?.nav?.OVER_MAX_SPEED === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                        {
                                            ((props.mode === "Bulk" && ((devices.length > 0 && (devices[0].deviceModel.name === "4K" || devices[0].deviceModel.name === "AIR2")) || !applyScopes.includes("Partial"))) || (props.mode === "Single" && allSpecificEvents?.others)) &&
                                            <Grid container style={{ marginTop: 5 }}>
                                                <Grid item xs={12} style={{ marginTop: 15 }}>
                                                    <Fragment>
                                                        <label >
                                                            {messages["configuration_upload_mode_others_events"]}
                                                        </label>
                                                    </Fragment>
                                                </Grid>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_manual"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_MANUAL-none"
                                                            onClick={e => {
                                                                allSpecificEvents.others.MANUAL = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.others.MANUAL === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_MANUAL-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.others.MANUAL = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.others.MANUAL === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_MANUAL-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.others.MANUAL = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.others.MANUAL === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                                    <Grid item xs={12}>
                                                        {messages["configuration_upload_mode_power_lost"]}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POWER_LOST-none"
                                                            onClick={e => {
                                                                allSpecificEvents.others.POWER_LOST = "none";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_none"], allSpecificEvents.others.POWER_LOST === "none")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POWER_LOST-clip"
                                                            onClick={e => {
                                                                allSpecificEvents.others.POWER_LOST = "clip";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_clip"], allSpecificEvents.others.POWER_LOST === "clip")
                                                            }
                                                        </div>
                                                        <div
                                                            className="d-sm-inline-block mb-1 vidfleet-pills"
                                                            key="CUPM_POWER_LOST-picture"
                                                            onClick={e => {
                                                                allSpecificEvents.others.POWER_LOST = "picture";
                                                                setAllGroupEvents({ ...allSpecificEvents });
                                                            }}
                                                        >
                                                            {
                                                                getBadget(messages["configuration_upload_mode_picture"], allSpecificEvents.others.POWER_LOST === "picture")
                                                            }
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                }
                            </Grid>
                        </CardContent>
                    </Card>
                )
            case 2:
                return (
                    <Card>
                        <CardContent>
                            {
                                (applyScopes.includes("Default") || applyScopes.includes("All") || !props?.device?.esn) && !codeSent &&
                                <Grid xs={12} style={{ marginTop: 20 }}>
                                    <a className="btn-link align-middle" onClick={() => {
                                        //to send the verification code
                                        let manufacturer = manufacturers.find(x => x?.name?.toUpperCase() === "VidFleet".toUpperCase())
                                        dispatch(generateValidationCode("updateVidFleetEventUploadMode", "VidFleet", manufacturer?.id))
                                        setSendfVC(true);
                                        setCodeSent(true);
                                    }}>
                                        {messages["vidfleet_configuration_send_verification_code"]}
                                    </a>
                                </Grid>
                            }
                            {
                                (applyScopes.includes("Default") || applyScopes.includes("All") || !props?.device?.esn) &&
                                <Grid xs={12} style={{ marginTop: 20 }}>
                                    <Input
                                        type="text"
                                        label={messages['vidfleet_configuration_verification_code']}
                                        placeholder={messages['vidfleet_configuration_verification_code']}
                                        value={verificationCode || ""}
                                        autoComplete="off"
                                        onChange={(value) => setVerificationCode(value?.trim())}
                                        requiredMessage={messages['required_field']}
                                        required
                                        maxLength={20}
                                    />
                                </Grid>
                            }
                        </CardContent>
                    </Card>
                )
                break;
            default:
                return (<div>empty</div>)
        }
    }

    //To save the upload mode configuration selected
    const saveConfigUploadMode = () => {
        let applScps = applyScopes;
        let esn = props?.device?.esn || null;
        let deviceId = props?.device?.id || null;
        let devicesIds = [];
        let esns = []
        let config = {}
        if (settingsMode === "ALL") {
            config = {
                allEvents: allEvents
            };
        } else if (settingsMode === "GROUPS") {
            config = allGroupEvents;
        } else {
            let mapEvents = {}//{ ...allSpecificEvents.accel, ...allSpecificEvents.dms, ...allSpecificEvents.adas, ...allSpecificEvents.others }
            if (allSpecificEvents.accel)
                mapEvents = { ...mapEvents, ...allSpecificEvents.accel }
            if (allSpecificEvents.dms)
                mapEvents = { ...mapEvents, ...allSpecificEvents.dms }
            if (allSpecificEvents.adas)
                mapEvents = { ...mapEvents, ...allSpecificEvents.adas }
            if (allSpecificEvents.others)
                mapEvents = { ...mapEvents, ...allSpecificEvents.others }
            if (allSpecificEvents.nav)
                mapEvents = { ...mapEvents, ...allSpecificEvents.nav }

            config = {
                events: mapEvents
            }
        }

        if (props.mode === "Bulk" && applScps.includes("Partial")) {
            devices.map((device, index) => {
                esns.push(device.esn);
                devicesIds.push(device.id);
            })
        } else {
            if (esn) {
                esns.push(esn)
                devicesIds.push(deviceId)
            } else if (props.mode !== "Bulk") {
                applScps = ["Default"];
            }
        }

        dispatch(vidfleetConfigurationUploadModeSave(config, esns, devicesIds, lastConfig, applScps, verificationCode))
    }

    useEffect(() => {

        if (saveResult) {
            dispatch(clearRedux("CONFIGURATION_UPLOAD_MODE", { saveResult: null }));

            if (!saveResult.error && saveResult?.result !== 'false') {
                NotificationManager.success(
                    "",
                    messages["configuration_upload_mode_save_success"],
                    3000,
                    null,
                    null,
                    'success'
                );
                hide();
            }
            else {
                let message = messages["configuration_upload_mode_save_error"]
                if (saveResult.error && saveResult.error.error) {
                    if (messages[saveResult.error.error])
                        message = messages[saveResult.error.error]
                    else
                        message = saveResult.error.error.replace("Bad request ->", "").replace("GraphQL error: ", "")
                } else if (saveResult.error && saveResult.error.message)
                    message = messages[saveResult.error.message]

                //Error message
                NotificationManager.error(
                    messages["configuration_upload_mode_save_title"],
                    message,
                    3000,
                    null,
                    null,
                    'error'
                );
                setCodeSent(false);
            }

        }

        if (data) {
            dispatch(clearRedux("CONFIGURATION_UPLOAD_MODE", { data: null }))
            if (data?.error?.response?.data?.msg) {
                NotificationManager.error(
                    "",
                    data.error.response.data.msg,
                    6000,
                    null,
                    null,
                    'error'
                );
            }
            if (data?.mode === "Single") {
                if (data?.devices)
                    setDevices(data.devices)
            }
            resolveData(data);

        }

        if (VfCodeResult && sendfVC) {
            dispatch(clearRedux("COMMON", { VfCodeResult: null }));
            setSendfVC(false);
            if (!VfCodeResult.error) {
                if (VfCodeResult.result) {
                    NotificationManager.success(
                        '',
                        messages["vidfleet_configuration_vf_code_sent"],
                        3000,
                        null,
                        null,
                        'success'
                    );
                } else {
                    //Error message
                    NotificationManager.error(
                        messages["configuration_upload_mode_title"],
                        messages["vidfleet_configuration_vf_code_error"],
                        3000,
                        null,
                        null,
                        'error'
                    );
                }
            } else {
                //Error message
                NotificationManager.error(
                    messages["configuration_upload_mode_title"],
                    messages["vidfleet_configuration_vf_code_error"],
                    3000,
                    null,
                    null,
                    'error'
                );
            }
            //message verification code send
        }

    }, [data, saveResult, VfCodeResult]);

    useEffect(() => {
        if (devicesToRecibe) {
            dispatch(clearRedux("DEVICES_COMMON", { devices: null }))
            let deviceSearchCriteriaArr = deviceSearchCriteria.split(/[\s,;\t\n]+/);
            let errorMsg = ""
            let dvcs = devices;

            if (deviceSearchCriteriaArr.length > 1) {

                if (devicesToRecibe.length === 0)
                    errorMsg = "vidfleet_configuration_device_not_found";

                let devicesReceived = devicesToRecibe.filter(x => {
                    return (deviceSearchCriteriaArr.includes(x.esn))
                })

                let deviceModel = devicesReceived[0].deviceModel;
                devicesReceived.forEach(deviceReceived => {

                    //repeated device
                    var foundDevice = dvcs.find(x => {
                        return x.esn === deviceReceived.esn
                    })

                    if (!foundDevice) {
                        //no VidFleet and diferent model
                        if (deviceReceived.deviceModel.manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase()) {
                            errorMsg = "vidfleet_configuration_only_vidfleet_devices"
                        } else {
                            dvcs.push(deviceReceived);
                        }

                    } else {
                        errorMsg = "vidfleet_configuration_repetead_on_the_list"
                    }

                });


                setDeviceSearchCriteria("");
                setErrorMessage(errorMsg);
                setDevices(dvcs);

            } else {
                errorMsg = "";
                //valid that has all valid devices
                let isValid = true;

                var device = devicesToRecibe.find(x => {
                    return x.esn === deviceSearchCriteria
                })

                if (!device) {
                    errorMsg = "vidfleet_configuration_device_not_found";
                    isValid = false;
                } else {
                    dvcs.forEach(d => {
                        if (d.esn === device.esn) {
                            errorMsg = "vidfleet_configuration_repetead_on_the_list"
                            isValid = false;
                        }
                    });
                }

                //review if VidFleet is a VidFleet device
                if (device && device.deviceModel.manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase()) {
                    isValid = false;
                    errorMsg = "vidfleet_configuration_only_vidfleet"
                }

                //review if is the same device model
                let deviceModel = null;
                if (dvcs.length > 0) {
                    deviceModel = dvcs[0].deviceModel;
                }

                if (dvcs.length > 0 && device && device.deviceModel.name !== deviceModel.name) {
                    isValid = false;
                    errorMsg = "vidfleet_configuration_only_same_model"
                }

                if (isValid) {
                    dvcs.push(device);
                    setDeviceSearchCriteria("");
                    setErrorMessage(errorMsg);
                    setDevices(dvcs);
                } else {
                    setErrorMessage(errorMsg);
                }
            }

        }

    }, [devicesToRecibe]);

    return (
        <Modal
            title={`${messages[title]}`}
            open={openModal}
            size="medium"
            handleClose={() => hide()}
            loading={loading || loadingVfCode}
            position="right"
        >

            <ModalBody style={{ backgroundColor: '#f8f8f8' }}>
                <Grid item xs={12}>
                    {
                        <Grid item className="" style={{ width: '100%' }}>
                            <ProgressBar
                                steps={(applyScopes.includes("Default") || applyScopes.includes("All")) ? 3 : 2}
                                activeStep={step}
                            />
                        </Grid>
                    }
                </Grid>
                <Grid item xs={12}>
                    {getStepsRender(step)}
                </Grid>
            </ModalBody>
            <ModalFooter>
                <Grid container>
                    <Grid item xs={12}>
                        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <Button size="lg" className="btn btn-cancel"
                                onClick={() => { hide(); }}
                            >
                                {messages["common_cancel"]}
                            </Button>
                            {
                                mode === "Bulk" && step > 0 &&
                                <Button size="lg" className="btn btn-dark-blue" onClick={(e) => {
                                    //back step
                                    setStep(step - 1);
                                }}>
                                    {messages["configuration_upload_mode_back"]}
                                </Button>
                            }
                            {
                                mode === "Bulk" && ((applyScopes.includes("Default") || applyScopes.includes("All")) ? step < 2 : step === 0) &&
                                <Button size="lg" className="btn btn-dark-blue" disabled={applyScopes.length === 0 || (devices.length === 0 && applyScopes.includes("Partial")) || loadingDevices} onClick={(e) => {
                                    //next step
                                    setStep(step + 1);
                                }}>
                                    {messages["configuration_upload_mode_next"]}
                                </Button>
                            }
                            {
                                (mode === "Single" || ((applyScopes.includes("Default") || applyScopes.includes("All")) ? step === 2 : step === 1)) &&
                                <Button
                                    size="lg"
                                    className="btn btn-dark-blue"
                                    disabled={!allSpecificEvents?.accel ||
                                        (mode === "Bulk" && applyScopes.length === 0) ||
                                        (mode === "Bulk" && applyScopes.includes("Partial") && devices.length === 0) ||
                                        (mode === "Bulk" && ((applyScopes.includes("All") || applyScopes.includes("Default")) && verificationCode === "")) ||
                                        (mode === "Single" && (!props?.device?.esn && verificationCode === ""))}
                                    onClick={(e) => {
                                        saveConfigUploadMode();
                                    }}>
                                    {messages["configuration_upload_mode_apply"]} {mode === "Bulk" && applyScopes.includes("Partial") ? ` (${devices.length})` : ``}
                                </Button>
                            }
                        </div>
                    </Grid>
                </Grid>
            </ModalFooter>
        </Modal >
    )
}

export default injectIntl(configureUploadMode);